import { useEffect, useState } from 'react';

/**
 * Обратный отсчёт до момента `until` (ms epoch) в секундах; 0 — истёк/не задан.
 * Тикает раз в секунду, пока не дойдёт до нуля. Для таймеров повторной
 * отправки кода (№20-в: сервер держит интервал 60 с — UI показывает его,
 * а не даёт нажать и получить 429).
 */
export function useCountdown(until: number | null): number {
  const compute = (): number => (until ? Math.max(0, Math.ceil((until - Date.now()) / 1000)) : 0);
  const [left, setLeft] = useState<number>(compute);
  useEffect(() => {
    setLeft(compute());
    if (!until) return undefined;
    const id = window.setInterval(() => {
      const next = compute();
      setLeft(next);
      if (next <= 0) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [until]);
  return left;
}

/** Секунды до повтора из 429-ответа (`details.retry_after_seconds`), иначе дефолт. */
export function retryAfterSeconds(
  details: Record<string, unknown> | undefined,
  fallback = 60,
): number {
  const raw = details?.retry_after_seconds;
  return typeof raw === 'number' && raw > 0 ? raw : fallback;
}
